<template>
  <div class="container-fluid" style="padding:0;overflow-x:hidden">
      <div style='font-size:18pt;margin:auto;width:auto;font-weight:bold;text-align:center'>
          {{title}}</div>

      <div v-if="mode == 'add'" style='font-size:12pt'>
        <table style='width:40%;margin:auto'>
          <tr>
            <td> Key Label</td><td>:</td>
            <template v-if="showkey[0]">
              <td> <input type="text" class="input" v-model="keylabel" size="30" maxsize="50"/> </td>
              <td> <img src='../assets/eyeshow.png' width="40" height="35" @click=toggle(0)></td>
            </template>
            <template v-if="! showkey[0]">
              <td><input type="password" class="input" v-model="keylabel" size="30" maxsize="50"/></td>
              <td><img src='../assets/eyehide.png' width="40" height="35" @click=toggle(0)></td>
            </template>
          </tr>
          <tr>
            <td>
              <select v-model="selected_key">
                <option v-for="k in keytypes" :value="k.id" :key="k.id">
                  {{k.name}}
                </option>
              </select>
            </td>
            <td>:</td>
            <template v-if="showkey[1]">
              <td> <input type="text" class="input" v-model="keydata" size="30" maxsize="50"/> </td>
              <td> <img src='../assets/eyeshow.png' width="40" height="35" @click=toggle(1)></td>
            </template>
            <template v-if="! showkey[1]">
              <td><input type="password" class="input" v-model="keydata" size="30" maxsize="50"/></td>
              <td><img src='../assets/eyehide.png' width="40" height="35" @click=toggle(1)></td>
            </template>
          </tr>
          <tr>
            <td>KCV</td>
            <td>:</td>
            <template v-if="showkey[2]">
              <td> <input type="text" class="input" v-model="kcv" size="30" maxsize="50"/> </td>
              <td> <img src='../assets/eyeshow.png' width="40" height="35" @click=toggle(2)></td>
            </template>
            <template v-if="! showkey[2]">
              <td><input type="password" class="input" v-model="kcv" size="30" maxsize="50"/></td>
              <td><img src='../assets/eyehide.png' width="40" height="35" @click=toggle(2)></td>
            </template>
          </tr>
          <tr>
          <td>LMKID</td>
            <td>:</td>
            <template v-if="showkey[3]">
              <td> <input type="text" class="input" v-model="lmkid" size="30" maxsize="50"/> </td>
              <td> <img src='../assets/eyeshow.png' width="40" height="35" @click=toggle(3)></td>
            </template>
            <template v-if="! showkey[3]">
              <td><input type="password" class="input" v-model="lmkid" size="30" maxsize="50"/></td>
              <td><img src='../assets/eyehide.png' width="40" height="35" @click=toggle(3)></td>
            </template>
          </tr>
        </table>
      </div>

      <div v-if="mode == 'browse'" class="table-responsive" style='font-size:10pt'>
        <table class="table table-striped table-bordered font-custom">
            <thead>
                <tr>
                    <th class="d-none d-md-block">CHECK</th>
                    <th v-for="h in brwheader" :key="h"> {{ h }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="myrow in brwdata" :key="myrow.cols[0]">
                    <td class="d-none d-md-block"><input type="checkbox" :value="myrow.cols[0]" @click="do_checkbox(myrow.cols[0])" 
                          v-model="myrow.selected"/></td>
                    <td v-for="c in myrow.cols" :key="c" class="colpad">
                      {{ c }}</td>
                </tr>
            </tbody>
        </table>

      </div>

      <div>
        <br>
        <div v-if="errormsg !=''" class="border mb-3" 
          style='color:red;background:yellow'>
          {{errormsg}}
        </div>

        <div v-if="mode == 'add'">
          <table style='width:10%;margin:auto;bottom-margin:10%'>
            <tr><td> 
              <button class="btn btn-primary btn-block mb-4" @click="do_add">
                Save</button>
              </td>
              <td>
              <button class="btn btn-primary btn-block mb-4" @click="changemode('browse')"> 
                Cancel</button>
              </td>
            </tr></table>
        </div>

        <div v-if="mode=='browse'">
          <table align="center">
          <tr>

            <td>
            <button class="btn btn-primary btn-block mb-4" @click="getbrowse('next')"> 
              Next</button></td>

            <td>
            <button class="btn btn-primary btn-block mb-4" @click="getbrowse('prev')"> 
              Prev</button></td>

            <td> 
            <button class="btn btn-primary btn-block mb-4" @click="getbrowse('first')"> 
              First</button></td>
            <td> 
            <button class="btn btn-primary btn-block mb-4" @click="getbrowse('last')"> 
              Last</button></td>

            <td> <div style="width:30px"></div></td>

            <td class="d-none d-md-inline">
            <button class="btn btn-primary btn-block mb-4" @click="changemode('add')"> 
              Add</button></td>

            <td class="d-none d-md-inline">
            <button class="btn btn-primary btn-block mb-4" @click="do_action('delete')"> 
              Delete</button></td>

            <td class="d-none d-md-inline">
              <button class="btn btn-primary btn-block mb-4" @click="do_action('verify')"> 
              Verify</button></td>

            <td class="d-none d-md-inline">
              <button class="btn btn-primary btn-block mb-4" @click="do_action('activate')"> 
              Activate</button></td>

          </tr></table>
        </div>
      </div>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.colpad {
    padding: 0.1rem !important ;
}
.bd-login {
    padding: 2rem;
    margin:  auto;
    border-width: 1px;
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
    width : auto;
}
footer {
   position: absolute ;
   bottom : 1rem ;
}
.spaceleft {
  left : 1rem ;
  position : relative;
  color: grey ;
  font-size : 14pt ;

}
header {
   position: absolute ;
   top : 0.5rem ;
   height : 3rem ;
}
</style>

<script>
import axios from 'axios'

export default {
  name: 'KeyInput',
  props: {
    msg: String
  },
  mounted() {
    this.getconfig();
    this.getbrowse('first');
  },
  computed: {
    title() {
      if (this.mode == "browse")
        return "KEY TABLES"
      else
        return "ADD KEY"

    },
    startseq() {
      let x = this.brwdata[0] ;
      if (! x) return 0 ;
      if (! x.cols) return 0 ;
      return x.cols[0] ;
    },
    userlogin() {
      return this.$store.getters.userlogin ;
    },
    curpage() {
      return this.$store.getters.curpage ;
    },
    targetobj() {
      for (let obj of this.brwdata) {
        if (obj.selected) 
          return parseInt(obj.cols[0]) ;
      }
      return 0 ;
    }
  },
  data() {
    return { 
      mode : "browse",
      config : null,
      keytypes : [ { id : "NONE", name : "NONE" } ],
      showkey : [ 0, 0, 0, 0 ],
      selected_key : "NONE",
      numoferr : 0,
      errormsg : '',
      keylabel : '',
      keydata  : '',
      brwheader : [ "id", "KeyLabel", "InputDate", "Validation", "KCV", "HSM Response", "Status" ],
      brwdata   : [ 
                    { "selected" : false,
                      "cols" : [ "0", "ID12345.ZMK.2023",
                        "07/08/2023 10:00", "07/08/2023 11:00", "123456", "00-SUCCESS", "NEW" ]
                    }
                  ],
      kcv   : '',
      lmkid : ''
    }
  },
  methods : {
    do_checkbox(seq) {
      for ( let r of this.brwdata ) {
        if (r.cols[0] != seq && r.selected) 
          r.selected = false ;
      }
    },
    changemode (newmod) {
      this.errormsg = "" ;
      this.mode = newmod ;
    },
    getbrowse(cmd) {
       let req = this.$store.getters.controller_url +
              "/prosw/CFG/sendkey/" + cmd + "?swapid=" + 
              this.$store.getters.controllerid + "&seq=" + this.startseq ;
        axios.get (req, {
            timeout: 10000,
            headers: {'Pswtoken': this.$store.getters.pswtoken } 
        }).then ( (response) => {
           if (typeof response.data != "object") 
              this.errormsg = "Invalid RESPONSE receive (not json)" ;
           else
           if (response.data.RC != "00")
              this.errormsg = "ERROR RESPONSE " + 
                        response.data.RC + " - " + response.data.RDESC ; 
           else {
              this.errormsg = "" ;
              this.brwdata = response.data.RESULT.brwdata ;
              this.brwheader = response.data.RESULT.brwheader ;
           }
        }).catch ( (error) => { console.log(error) })
    },
    do_action(cmd) {
       if (this.targetobj == 0) {
          this.errormsg = "No Target Object Please Check target row"  ;
          return ;
       }
       if (cmd == 'delete') {
         if (! confirm("Remove File ?")) return ;
       }
       let req = this.$store.getters.controller_url +
              "/prosw/CFG/sendkey/" + cmd + "?swapid=" + 
              this.$store.getters.controllerid + "&seq=" + this.startseq +
                  "&target=" + this.targetobj ;
       axios.get (req, {
            timeout: 10000,
            headers: {'Pswtoken': this.$store.getters.pswtoken } 
        }).then ( (response) => {
           if (typeof response.data != "object") 
              this.errormsg = "Invalid RESPONSE receive (not json)" ;
           else
           if (response.data.RC != "00")
              this.errormsg = "ERROR RESPONSE " + 
                        response.data.RC + " - " + response.data.RDESC ; 
           else {
              this.errormsg = response.data.RDESC ;
              this.brwdata = response.data.RESULT.brwdata ;
              this.brwheader = response.data.RESULT.brwheader ;
           }
        }).catch ( (error) => { console.log(error) })
    },
    getconfig() {
       let req = this.$store.getters.controller_url +
              "/prosw/CFG/get?filename=swap/keyinput.yaml&swapid=" + 
              this.$store.getters.controllerid ;
        axios.get (req, {
            timeout: 10000,
            headers: {'Pswtoken': this.$store.getters.pswtoken } 
        }).then ( (response) => {
           if (typeof response.data != "object") 
              this.errormsg = "Invalid RESPONSE receive (not json)" ;
           else
           if (response.data.RC != "00")
              this.errormsg = "ERROR RESPONSE " + 
                        response.data.RC + " - " + response.data.RDESC ; 
           else {
              this.config = response.data.RESULT ; 
              this.keytypes = this.config.keyoptions ;
              this.selected_key = this.keytypes[0].id ;
              this.showkeys = this.config.showkeys ;
              let a = []
              for (let i = 0 ; i < this.showkeys.length ;i++) {
                 a[i] = (this.showkeys[i] == "show") ? 1 : 0 ;
              }
              this.showkey  = a ;
           }
        }).catch ( (error) => { console.log(error) })
    },
    do_add() {
       let req = this.$store.getters.controller_url +
        "/prosw/CFG/sendkey/save?swapid=" + this.$store.getters.controllerid + 
          "&seq=" + this.startseq ;

       if (this.keydata == "") {
         this.errormsg = "input data required!"
         return ;
       }
       let k = null ;
       for (let i = 0 ; i < this.keytypes.length ; i++) {
         k = this.keytypes[i] ;
         if (k.id == this.selected_key )
           break ;
       }     
       if (! k || k.id != this.selected_key) {
         this.errormsg = "selection not in table: " + this.selected_key;
         return ;
       }

       if (k.check && k.check.length > 0) {
          for (let i = 0 ;i < k.check.length ; i++) {
            let cond = k.check[i] ;
            let input = this.keydata ;
            if (! eval (cond.cond)) {
              this.errormsg = cond.error;
              return input ;
            }
          }
       }
       if (this.keydata == '') {
          this.errormsg = this.selected_key + " INPUT REQUIRED" ;
          return ;
       }
       if (this.keylabel == '') {
          this.errormsg = "KEYLABEL INPUT IS REQUIRED" ;
          return ;
       }

       if (this.kcv == '') {
          this.errormsg = "KCV INPUT IS REQUIRED" ;
          return ;
       }

       if (this.lmkid == '') {
          this.errormsg = "LMKID INPUT IS REQUIRED" ;
          return ;
       }

       let formData = new FormData();
       formData.append('keytype', this.selected_key);
       formData.append('keydata', this.keydata);
       formData.append('keylabel', this.keylabel);
       formData.append('kcv', this.kcv);
       formData.append('lmkid', this.lmkid);
       formData.append('sendto', this.config.sendto);
       formData.append('command', "add") ;

       axios.post(req, formData, {
                    headers: {
                        'Pswtoken': this.$store.getters.pswtoken, 
                        'Content-Type': 'multipart/form-data'
                    }
       }).then ( (response) => { 
           if (typeof response.data == "object") {
              let obj = response.data ;
              this.errormsg = "RC: " + obj.RC + " -- " + obj.RDESC  ;
              if (obj.RC == "00")  {
                this.keydata = "" ;
                this.keylabel = "" ;
                this.kcv = "" ;
                this.lmkid = "" ;
                this.brwdata = response.data.RESULT.brwdata ;
                this.brwheader = response.data.RESULT.brwheader ;
                this.mode = 'browse' ;
              }
            }
            else
              this.errormsg = "Invalid response" ;
           })
           .catch ( err => {  console.log(err) ; 
                              this.writemsg ( "RECV ERROR RESPONSE") } )  
    },
    toggle(idx) {
      this.showkey[idx] = ! this.showkey[idx];
    },
    writemsg(err) {
      if (this.numoferr > 0) 
         this.errormsg = err + "(" + this.numoferr + ")" ;
      else
         this.errormsg = err ;
      this.numoferr ++ ;
    }
  }
}
// vim:expandtab:smartindent:tabstop=2:softtabstop=2:shiftwidth=2:
</script>
